export default __webpack_public_path__ + "static/media/TRANSPORT 3.51143dad.jpg";